import React from "react";

const ModalShowContext = React.createContext();
ModalShowContext.displayName = "ModalShowContext";

export default ModalShowContext;